import "./_slider-text.scss";
import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", () => {
  const SliderTexts = document.querySelectorAll(".slider-texts");

  SliderTexts.forEach((slider) => {
    const hasNumber = slider.dataset.hasNumber === "true";
    const block = slider.closest(".block_slider-text");

    new Swiper(slider, {
      loop: false, // Disattivato loop per linearità di navigazione da tastiera
      speed: 600,
      slidesPerView: 1.2,
      watchSlidesProgress: true, // Traccia lo stato visivo delle slide a schermo
      keyboard: {
        enabled: true,
      },
      // Accessibilità nativa Swiper configurata in Italiano
      a11y: {
        enabled: true,
        prevSlideMessage: "Slide precedente",
        nextSlideMessage: "Slide successiva",
        slideLabelMessage: "Slide {{index}} di {{slidesLength}}",
      },
      // Collegamento alle nuove frecce direzionali inserite nel PHP
      navigation: {
        nextEl: block.querySelector(".swiper-button-next-custom"),
        prevEl: block.querySelector(".swiper-button-prev-custom"),
      },
      // Collegamento alla paginazione numerica (frazione)
      pagination: {
        el: block.querySelector(".swiper-pagination"),
        type: "fraction",
      },
      spaceBetween: hasNumber ? 16 : 30,
      breakpoints: {
        640: { slidesPerView: 2.2 },
        992: { slidesPerView: 3.2 },
        1440: {
          spaceBetween: hasNumber ? 40 : 84,
          slidesPerView: 3.2,
        },
      },
      on: {
        init: function () {
          updateSwiperA11y(this);
        },
        slideChangeTransitionEnd: function () {
          updateSwiperA11y(this);
          announceSlideUpdate(this); // Annuncio vocale al cambio slide manuale
        },
        resize: function () {
          updateSwiperA11y(this);
        },
      },
    });
  });

  // =========================================================================
  // GESTIONE ATTRIBUTI DI ACCESSIBILITÀ E FOCUS ORDINATO
  // =========================================================================

  function updateSwiperA11y(swiper) {
    swiper.slides.forEach((slide) => {
      // Isoliamo il blocco di testo (e gli eventuali link interni)
      const focusableElements = slide.querySelectorAll(".slide-content, a");

      // Accendiamo o spegniamo i tabindex in base alla reale visibilità a schermo
      if (slide.classList.contains("swiper-slide-visible")) {
        slide.setAttribute("aria-hidden", "false");
        focusableElements.forEach((el) => el.setAttribute("tabindex", "0"));
      } else {
        slide.setAttribute("aria-hidden", "true");
        focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));
      }
    });

    // Gestione dello stato dei bottoni quando arrivano a inizio/fine corsa
    const nextBtn = swiper.navigation.nextEl;
    const prevBtn = swiper.navigation.prevEl;

    const checkBtnDisabled = (btn) => {
      if (btn) {
        if (btn.classList.contains("swiper-button-disabled")) {
          btn.setAttribute("tabindex", "-1");

          // Se l'utente era con il focus sulla freccia che si disabilita,
          // spostiamo il focus sul contenuto della slide attiva per non perdere l'orientamento
          if (document.activeElement === btn) {
            swiper.slides[swiper.activeIndex]
              .querySelector(".slide-content")
              ?.focus();
          }
        } else {
          btn.setAttribute("tabindex", "0");
        }
      }
    };

    checkBtnDisabled(nextBtn);
    checkBtnDisabled(prevBtn);
  }

  // Genera un annuncio discreto per gli screen reader ad ogni click sulle frecce
  function announceSlideUpdate(swiper) {
    const liveRegionId = "swiper-text-live-announcer";
    let liveRegion = document.getElementById(liveRegionId);

    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.id = liveRegionId;
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.style.position = "absolute";
      liveRegion.style.width = "1px";
      liveRegion.style.height = "1px";
      liveRegion.style.overflow = "hidden";
      document.body.appendChild(liveRegion);
    }

    const current = swiper.activeIndex + 1;
    const total = swiper.slides.length;
    liveRegion.textContent = `Visualizzata slide testo ${current} di ${total}`;
  }
});
